export default "https://cdn-gra-staging.amplement.io/statics/sounds/outgoingRinging.mp3";